import { mapActions } from 'vuex';

//---helpers
import { globalLoader } from '@/helpers/variables';
import { BLOG_CONTENT_TYPE } from '@/helpers';

//---mixins
import { dynamicHead } from '@/mixins/dynamic-head.js';

//---components
import BreadcrumbsSimple from '@/components/@general/BreadcrumbsSimple/index.vue';
import ContentBlock from '@/components/custom/ContentBlock/index.vue';

export default {
  name: 'About',
  mixins: [dynamicHead],
  components: { ContentBlock, BreadcrumbsSimple },
  props: {},
  data() {
    return {
      BLOG_CONTENT_TYPE,
      aboutUsData: null
    };
  },
  created() {
    this._loadContent();
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    ...mapActions({
      getAboutUs: 'staticPages/GET_ABOUT_US'
    }),
    async _loadContent() {
      globalLoader(true);
      await this.getAboutUs().then((result) => {
        this.aboutUsData = result;
        this._setMetaParams();
      });

      globalLoader(false);
    },
    _setMetaParams() {
      let { title, metaTitle, metaDescription, metaImage } = this.aboutUsData;

      this.metaParams.title = `${metaTitle || title} ${this.$t('seo.metaTitleGeneral')}`;
      this.metaParams.description = metaDescription || `${metaTitle || title} ${this.$t('seo.metaDescGeneral')}`;
      this.metaParams.image = metaImage || null;
      this.setMeta();
    }
  }
};
